export default "__VITE_ASSET__636e0c2a__"